<h2 mat-dialog-title>{{ data.title }}</h2>
<div mat-dialog-content data-folders>
  <app-select-folder
    [config]="data.config"
    [createFolder$]="createFolder$.asObservable()"
    (select)="folderSelected($event)"
    (showCreateFolder)="showCreateFolder = $event"
  />
</div>
<div mat-dialog-actions>
  @if (showCreateFolder) {
    <button class="new-folder" mat-stroked-button color="primary" (click)="createFolder$.next()">
      New Folder
    </button>
  }

  <button mat-button [mat-dialog-close]="">Close</button>
  <button mat-flat-button color="primary" (click)="select()" [disabled]="!selected">Select</button>
</div>
